/**
 * Recurring-billing classification — shared client/server (Wave 1).
 *
 * THE one classifier every money path must share (2026-07 pricing audit).
 * Non-canonical snapshots (BP / signed-import paths that bypassed
 * scopeToRender) carry casings like 'Recurring' / 'recurring ' — splitting
 * an item's classification between a strict check (totals) and a tolerant
 * check (render) showed the customer an item under "Ongoing services"
 * while its money landed in the one-time bucket.
 *
 * Formerly hand-mirrored as quote-pricing's isRecurringBillingType
 * (client) and _acceptance-resolution's + _snapshot-pricing's
 * isRecurringBilling (server).
 */
export function isRecurringBillingType(billingType: unknown): boolean {
  return (
    typeof billingType === 'string' &&
    billingType.trim().toLowerCase() === 'recurring'
  );
}
